import React from "react";
import ReactQuill from "react-quill";
import { Typography, Col, Row, Card } from "antd";
import StoryTitleComponent from "./StoryTitleComponent";

const { Title, Text } = Typography;

const DIFFICULTY_OPTIONS = [
  { value: 1, label: "1 – Sehr leicht" },
  { value: 2, label: "2 – Leicht" },
  { value: 3, label: "3 – Mittel" },
  { value: 4, label: "4 – Anspruchsvoll" },
  { value: 5, label: "5 – Schwierig" },
];

const StoryDetailsSection = ({
  storyTitle,
  storyCategory,
  storyCoverImg,
  storyDescription,
  setStoryDescription,
  storyDifficulty,
  handleStoryDifficultyChange,
  handleTitleChange,
  handleCoverImageChange,
  handleStoryCategoryChange,
}) => {
  return (
    <>
      <Card className="editorContainer" bordered>
        <StoryTitleComponent
          title={storyTitle}
          category={storyCategory}
          coverImage={storyCoverImg}
          difficulty={storyDifficulty}
          onChange={handleTitleChange}
          handleCoverImageChange={handleCoverImageChange}
          handleStoryCategoryChange={handleStoryCategoryChange}
          handleStoryDifficultyChange={handleStoryDifficultyChange}
        />
      </Card>

      <Card className="editorContainer" bordered>
       
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Title level={4}>Übersicht der Geschichte </Title>
              <Text type="secondary">
                Geben Sie hier eine kurze Beschreibung Ihrer Geschichte an. Dies
                hilft anderen, einen Überblick über Ihre Geschichte zu erhalten.
              </Text>
            </Col>

            <Col span={24}>
              <ReactQuill
                className="editor"
                theme="snow"
                value={storyDescription}
                onChange={setStoryDescription}
                placeholder="Schreiben Sie die Übersicht der Geschichte..."
                style={{
                  height: "200px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                }}
              />
            </Col>
          </Row>
       
      </Card>
    </>
  );
};

export default StoryDetailsSection;
